import type { FaireProductEntity } from "../../entity_types/product";

export const p_3shg9kcsp4: FaireProductEntity = {
  token: "p_3shg9kcsp4",
  type: "product",
  name: "Custom Tote Bag (Your Logo / Your Own Design)",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/dda16896d50da0d7f2303577c1a35893dd97fbe7b7430c815a474d2266e11337.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ddf1f68720a60ebc9155ca7c59e87dd7c2a57a328aa08f99950ad4b448a01645.jpeg",
    "https://cdn.faire.com/fastly/5d49f056ca8ac1d8a9c86dd5ea972f34192eccbe541a68e16f6cf57bd8790144.jpeg",
    "https://cdn.faire.com/fastly/d77b19adea7e495ab6db6ead2f0042848665835ca12a1fe691fe11b182f586b3.jpeg",
    "https://cdn.faire.com/fastly/6e3703419ffc95e427c0757aefd2b3c5f0df50235995095f156bd0e05ee1f78c.jpeg"
  ],
  priceDollars: 12.5,
  description: "Customize this item with your artwork, logo or design!\n\nSimply submit your artwork and we'll print it for you! We kindly request the artwork to be in high resolution format. A PDF, EPS, PSD, or AI file is required to ensure the print is sharp and not pixelated. JPGs above 1000 pixels can be accepted.\n\nOur 100% cotton canvas tote bags are perfect for everyday use! These beautiful natural canvas shopping bags are great for a day at the beach and summer activities. Trendy and stylish, these eco-friendly handbags are a must-have for your clothes, towel, sunglasses and beach wear! Simply pair with your favorite tank and shorts and you're ready for the beach!\n\nTo purchase, kindly place your order and message us your artwork. A proof available upon request.\n\nMaterial:\n• 100% Cotton Canvas Fabric\n• 12-ounce heavy duty canvas\n\nSize:\n• 15\" W x 16\" H\n\nDesigned and printed in the USA\n\nSpot clean with warm water and mild detergent (do not machine wash)",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:45.332Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
